import {combineReducers} from 'redux';
import partnerDirectoryList from './partnerDirectoryList';
import partnerDirectoryDetails from './partnerDirectoryDetails';

export const opportunityLinkReducers = combineReducers({
  partnerDirectoryList: partnerDirectoryList,
  partnerDirectoryDetails: partnerDirectoryDetails,
});
